class CustomMadeFields extends HTMLElement {
  connectedCallback() {
    this.productDetails = this.closest('.product-information');
    this.productDetails?.addEventListener('change', this.updateVisibility);
    this.updateVisibility();
  }

  disconnectedCallback() {
    this.productDetails?.removeEventListener('change', this.updateVisibility);
  }

  updateVisibility = () => {
    const picker = this.productDetails?.querySelector('variant-picker');
    if (!picker) return;

    // Match the value only: option names are translated per storefront language, the value is not.
    const { optionValue } = this.dataset;
    const selected = picker.querySelectorAll('input[data-option-name]:checked, select option:checked');
    const isCustom = [...selected].some((input) => input.value === optionValue);

    this.hidden = !isCustom;
    this.querySelectorAll('input, textarea').forEach((field) => {
      field.disabled = !isCustom;
    });
  };
}

if (!customElements.get('custom-made-fields')) {
  customElements.define('custom-made-fields', CustomMadeFields);
}
